export const PAGE_SIZE = 10;

export const tablePagination = (page: number, setPage: (page: number) => void, total: number) => ({
  current: page,
  pageSize: PAGE_SIZE,
  total,
  showSizeChanger: false,
  hideOnSinglePage: true,
  showTotal: (count: number, range: [number, number]) =>
    count ? `${range[0]}–${range[1]} of ${count}` : "0",
  onChange: (next: number) => setPage(next),
});

export function matchesQuery(query: string, values: Array<string | number | null | undefined>) {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return values.some((value) => String(value || "").toLowerCase().includes(needle));
}
